<template>
  <div class="scene-manager">
    <el-dialog title="Konfiguracja projektu" :visible="visible" width="50%" v-if="loggedIn" :close-on-click-modal="false" @close="handleClose">
      <el-form ref="form" :model="formData" :disabled="loading" label-width="250px" label-position="left">
        <el-form-item label="Nazwa projektu">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>

        <el-form-item label="Eksportuj wszystkie wersje razem">
          <el-switch v-model="formData.exportAll"></el-switch>
        </el-form-item>

        <el-form-item label="Lista gości">
          <el-switch v-model="formData.showGuestList"></el-switch>
        </el-form-item>

        <el-row v-if="formData.versions.length">
          <el-divider content-position="center">Wersje</el-divider>

          <el-descriptions v-for="(version, index) in formData.versions" size="mini" :column="4" :key="index" :title="version.name">
            <template slot="extra">
              <i @click="handleEdit(version)" class="el-icon-edit"></i>
              <i @click="handleDelete(index)" class="el-icon-delete"></i>
            </template>

            <el-descriptions-item label="Rozmiar"> {{ version.size[0] }} x {{ version.size[1] }} </el-descriptions-item>
            <el-descriptions-item label="Obramowanie">{{ renderBorder(version.border) }} </el-descriptions-item>
            <el-descriptions-item label="Bezpieczny zadruk">{{ renderBorder(version.safePrint) }} </el-descriptions-item>
            <el-descriptions-item label="Spad">{{ renderBorder(version.margin) }} </el-descriptions-item>
            <el-descriptions-item label="Kolor obramowania">{{ version.borderColor }}</el-descriptions-item>
            <el-descriptions-item v-if="version.tabs.length" label="Zakładki">
              <el-tag v-for="tab in version.tabs" :key="tab" size="small">{{ tab }}</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </el-row>

        <el-divider content-position="center">{{ actionName }}</el-divider>

        <el-form-item label="Nazwa wersji">
          <el-input v-model="versionData.name"></el-input>
        </el-form-item>

        <el-form-item label="Rozmiar">
          <el-col :span="5">
            <el-input placeholder="Szerokość" v-model="versionData.size[0]"></el-input>
          </el-col>
          <el-col class="separator" :span="2">
            x
          </el-col>
          <el-col :span="5">
            <el-input placeholder="Wysokość" v-model="versionData.size[1]"></el-input>
          </el-col>
        </el-form-item>

        <BorderInput label="Bezpieczny zadruk" :value="versionData.safePrint" />
        <BorderInput label="Spad" :value="versionData.margin" />
        <BorderInput label="Obramowanie" :value="versionData.border" />

        <el-form-item v-if="versionData.border" label="Kolor obramowania">
          <el-color-picker v-model="versionData.borderColor"></el-color-picker>
        </el-form-item>

        <el-form-item label="Pole personalizowane">
          <el-switch v-model="versionData.personalizedField"></el-switch>
        </el-form-item>

        <el-form-item label="Zakładki">
          <el-checkbox-group v-model="versionData.tabs">
            <el-checkbox label="images" name="tabs">Obrazki</el-checkbox>
            <el-checkbox label="texts" name="tabs">Teksty</el-checkbox>
            <el-checkbox label="quotes" name="tabs">Cytaty</el-checkbox>
            <el-checkbox label="rhyme" name="tabs">Wierszyki</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-button type="success" @click="handleSaveVersion">{{ actionName }}</el-button>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Zamknij</el-button>
        <el-button type="primary" @click="handleSave">Zapisz</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BorderInput from './BorderInput.vue';
import { mapGetters, mapActions } from 'vuex';
// import { fabric } from 'fabric';
import cloneDeep from 'clone-deep';
import Editor from '../../classes/Editor';

const versionDraft = {
  name: 'Wariant',
  content: '',
  safePrint: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  margin: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  border: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  borderColor: '#ccc',
  tabs: [],
  personalizedField: false,
  size: ['115mm', '170mm'],
};

const templateDraft = {
  name: 'Nowy projekt',
  note: '',
  guests: [],
  guestCords: {
    x: 0,
    y: 0
  },
  exportAll: true,
  showGuestList: true,
  versions: [],
}

export default {
  name: 'SceneManager',
  props: {
    scene: {
      default: () => ({}),
      required: false,
    },
    visible: {
      require: true
    }
  },
  data() {
    return {
      edit: false,
      loading: false,
      versionData: cloneDeep(versionDraft),
      formData: cloneDeep(templateDraft),
    };
  },
  computed: {
    ...mapGetters('user', ['loggedIn']),
    ...mapGetters('creator', ['activeScene', 'activeVersion']),

    actionName() {
      return this.edit ? 'Zapisz wersję' : 'Dodaj wersję';
    },
  },
  methods: {
    ...mapActions('creator', ['newScene', 'setActiveSceneVersion', 'setScene']),

    removeNewVersion(index) {
      this.formData.versions.splice(index, 1);
    },
    handleSaveVersion() {
      if (!this.edit) {
        this.formData.versions.push(this.versionData);
      }
      this.edit = false;
      this.versionData = cloneDeep(versionDraft);
    },
    handleSave() {
      const scene = cloneDeep(this.formData);

      if (Object.values(this.scene).length) {
        this.setScene(cloneDeep(this.formData))
      } else {
        this.newScene(scene);
      }
      
      this.formData = cloneDeep(templateDraft)
      
      this.handleClose()

      Editor.refresh()
    },
    handleSafePrint(value) {
      this.versionData.safePrint.top = value;
      this.versionData.safePrint.bottom = value;
      this.versionData.safePrint.left = value;
      this.versionData.safePrint.right = value;
    },
    renderBorder(border) {
      if (this.allValuesTheSame(border)) {
        return `${border.top}`;
      }

      return `${border.top}/${border.right}/${border.bottom}/${border.left}`;
    },
    allValuesTheSame(border) {
      return Object.values(border).every((val, i, arr) => val === arr[0]);
    },
    handleEdit(version) {
      this.edit = true;
      this.versionData = version;
    },
    handleDelete(versionIndex) {
      this.formData.versions = this.formData.versions.filter((item, index) => index !== versionIndex);
    },
    handleClose() {
      this.$emit('close');
    }
  },
  watch: {
    visible() {
      if (Object.values(this.scene).length) {
        this.formData = cloneDeep(Object.assign(this.formData, this.scene));
      }
    }
  },
  components: {
    BorderInput,
  },
};
</script>

<style lang="less">
.separator {
  text-align: center;
}
.advanced.el-link {
  margin: 0;
  line-height: 1;
  font-weight: 400;
}
.size {
  p {
    font-size: 12px;
    margin: 0;
    line-height: 1;
  }
  + .size {
    margin-left: 20px;
  }
}
.el-descriptions {
  padding: 10px;
  border-radius: 2px;

  &,
  .el-descriptions__body {
    background: #f6f6f6;
  }

  + .el-descriptions {
    margin-top: 15px;
  }
}
.el-icon-edit,
.el-icon-delete {
  cursor: pointer;
}
.el-icon-delete {
  margin-left: 10px;
}
</style>
